import { render, staticRenderFns } from "./PreviewSequencesEmailProporsal.vue?vue&type=template&id=6ad71a38&scoped=true"
import script from "./PreviewSequencesEmailProporsal.vue?vue&type=script&lang=js"
export * from "./PreviewSequencesEmailProporsal.vue?vue&type=script&lang=js"
import style0 from "./PreviewSequencesEmailProporsal.vue?vue&type=style&index=0&id=6ad71a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad71a38",
  null
  
)

export default component.exports